import { apiGet, GetReportRequest } from 'api';
import { ReportResponse } from 'types';

export const getExtensionRequestsReport = (
  request: GetReportRequest
): Promise<ReportResponse> =>
  apiGet<ReportResponse, GetReportRequest>('reports/extensionrequests', request);
